import type { DataSimilars } from '../SimilarProducts/SimilarProducts'
// import { getSimilarProducts } from '../SimilarProducts/getSimilarsProducts'
import type { ProductType } from './ProductCardTypes'

interface HandleHoverProps {
  isMouseIn: boolean
  productImages: Array<{
    url: string
    alternateName: string
  }>
  setIsMouseOver: React.Dispatch<React.SetStateAction<boolean>>
  setCardImage: React.Dispatch<React.SetStateAction<string>>
  isMobile: boolean
  similars?: DataSimilars | null
  setSimilars?: React.Dispatch<React.SetStateAction<DataSimilars | null>>
  product?: ProductType
  hasFetchedSimilarData?: boolean
  setHasFetchedSimilarData?: React.Dispatch<React.SetStateAction<boolean>>
}

export function handleHover({
  isMouseIn,
  productImages,
  setIsMouseOver,
  setCardImage,
  isMobile,
}: /* product,
  setSimilars,
  similars,
  hasFetchedSimilarData,
  setHasFetchedSimilarData, */
HandleHoverProps) {
  if (isMobile) {
    return
  }

  setIsMouseOver(isMouseIn)
  const hoverImage = productImages?.filter((productimg) =>
    productimg?.url?.includes('_hover')
  )

  if (!isMouseIn) {
    setCardImage(productImages[0]?.url)
  }

  const hoverImageByLabel = productImages?.filter(
    (productimg) => productimg.alternateName === 'hover' && productimg.url
  )

  if (isMouseIn && hoverImage[0]?.url) {
    setCardImage(hoverImage[0]?.url)
  }

  if (isMouseIn && hoverImageByLabel[0]?.url) {
    setCardImage(hoverImageByLabel[0]?.url)
  }

  if (
    isMouseIn &&
    !hoverImage[0]?.url &&
    !hoverImageByLabel[0]?.url &&
    productImages[1]?.url
  ) {
    setCardImage(productImages[1]?.url)
  }

  if (
    isMouseIn &&
    !hoverImage[0]?.url &&
    !hoverImageByLabel[0]?.url &&
    !productImages[1]?.url
  ) {
    setCardImage(productImages[0]?.url)
  }

  /* if (
    product &&
    isMouseIn &&
    setSimilars &&
    !similars &&
    !hasFetchedSimilarData &&
    setHasFetchedSimilarData
  ) {
    getSimilarProducts({ setSimilars, product })
    setHasFetchedSimilarData(true)
  } */
}
